import axios from "axios";
import { startLoading, stopLoading } from "../reducers/loadingReducer";
import store from '../store';

const instance = axios.create({
  baseURL: "https://teaapitest.azurewebsites.net/",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("accessToken");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  store.dispatch(startLoading());
  return config;
});

instance.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  async function (error) {
    store.dispatch(stopLoading());
    if (error.response.status === 401) {
      localStorage.removeItem("accessToken");
    }
    return Promise.reject(error);
  }
);

export default instance;